import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { WebGLRenderer, Scene, PerspectiveCamera } from 'three';
import CanvasRenderer from '../CanvasRenderer';
import webglAvailable from './webglAvailable';

const propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,

    createScene: PropTypes.func,
    createRenderer: PropTypes.func,
    createCamera: PropTypes.func,

    fov: PropTypes.number,
    minDepth: PropTypes.number,
    maxDepth: PropTypes.number,
    rendererOptions: PropTypes.shape({}),

    children: PropTypes.element,
    className: PropTypes.string,
    style: PropTypes.object,

    onReady: PropTypes.func,
    onTickReady: PropTypes.func,
};

const defaultProps = {
    width: null,
    height: null,
    createScene: null,
    createRenderer: null,
    createCamera: null,
    fov: 75,
    minDepth: 10.1,
    maxDepth: 10000,
    rendererOptions: null,
    children: null,
    className: null,
    style: null,
    onReady: null,
    onTickReady: null,
};

class PixiCanvas extends Component {
    constructor(props) {
        super(props);

        this.element = null;
        this.renderer = null;
        this.scene = null;
        this.camera = null;

        this.tick = this.tick.bind(this);
    }

    componentDidMount() {
        this.renderer = this.createRenderer();
        this.scene = this.createScene();
        this.camera = this.createCamera();

        this.onReady();
    }

    componentDidUpdate(prevProps) {
        const sizeChanged = (
            prevProps.width !== this.props.width ||
            prevProps.height !== this.props.height
        );
        if (sizeChanged) {
            this.resize();
        }
    }

    componentWillUnmount() {
        if (this.renderer) {
            this.renderer.dispose();
        }
    }

    onReady() {
        if (this.props.onReady) {
            this.props.onReady(this.renderer, this.scene, this.camera);
        }

        if (this.props.onTickReady) {
            this.props.onTickReady(this.tick);
        }
    }

    /**
     * Methods
     */
    createRenderer() {
        const { width, height, createRenderer, rendererOptions } = this.props;
        if (createRenderer) {
            return this.props.createRenderer(this.element, width, height);
        }

        const renderer = !webglAvailable() ? new CanvasRenderer(

        ) : new WebGLRenderer({
            antialias: true,
            alpha: false,
            canvas: this.element,
            precision: 'mediump',
            ...rendererOptions,
        });
        renderer.setPixelRatio(window.devicePixelRatio ? window.devicePixelRatio : 1);
        renderer.setSize(width, height);
        return renderer;
    }

    createScene() {
        if (this.props.createScene) {
            return this.props.createScene();
        }

        const scene = new Scene();
        return scene;
    }

    createCamera() {
        if (this.props.createCamera) {
            return this.props.createCamera();
        }

        const {
            fov,
            minDepth,
            maxDepth,
            width,
            height,
        } = this.props;

        const camera = new PerspectiveCamera(fov, width / height, minDepth, maxDepth);
        return camera;
    }

    resize() {
        if (this.camera) {
            this.camera.aspect = this.props.width / this.props.height;
            this.camera.updateProjectionMatrix();
        }
        if (this.renderer) {
            this.renderer.setSize(this.props.width, this.props.height);
        }
    }

    tick() {
        if (this.renderer && this.scene) {
            this.renderer.render(this.scene, this.camera);
        }
    }

    render() {
        const {
            children,
            className,
            style,
        } = this.props;
        return (
            <canvas
                className={className}
                style={style}
                ref={(ref) => { this.element = ref; }}
            >
                { children }
            </canvas>
        );
    }
}

PixiCanvas.propTypes = propTypes;
PixiCanvas.defaultProps = defaultProps;

export default PixiCanvas;



// WEBPACK FOOTER //
// ./vendor/react-draw/Three.jsx